import React from 'react';
import '../styling/LayoutCommon.module.css';

export default function Header(props) {
	return (
		<h2>{ props.title }</h2>
	);
}